import React from 'react';
import { Clock, Activity, Crown } from 'lucide-react';

interface WorkoutPreviewProps {
  workout: {
    id: string;
    name: string;
    duration: number;
    strain: number;
    level: string;
    image: string;
    coach: {
      name: string;
    };
  };
  onSelect: () => void;
}

export function WorkoutPreview({ workout, onSelect }: WorkoutPreviewProps) {
  const isElite = workout.level === 'Elite';

  return (
    <div 
      onClick={onSelect}
      className="theme-card group relative overflow-hidden cursor-pointer"
    >
      {/* Thumbnail */}
      <div className="relative h-40 overflow-hidden">
        <img
          src={workout.image}
          alt={workout.name}
          className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500"
          onError={(e) => {
            e.currentTarget.src = 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent opacity-60" />
        
        {isElite && (
          <div className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 rounded-full bg-amber-500/20 backdrop-blur-sm text-amber-500 text-xs">
            <Crown className="w-3 h-3" />
            Elite
          </div>
        )}
      </div>
      
      {/* Content */}
      <div className="p-4 space-y-3">
        <div>
          <h3 className="font-medium line-clamp-1">{workout.name}</h3>
          <p className="text-sm text-muted-foreground line-clamp-1">with {workout.coach.name}</p>
        </div>

        <div className="flex items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Clock className="w-4 h-4" />
            {workout.duration}m
          </div>
          <div className="flex items-center gap-1">
            <Activity className="w-4 h-4" />
            {workout.strain.toFixed(1)}
          </div>
        </div>
      </div>

      {/* Hover Effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" />
    </div>
  );
}